import { takeLatest, put, call } from "redux-saga/effects";
import { FETCH_LIST_REQUEST, REDIRECT_TO_LOGIN } from "./actionsTypes";
import { fetchListSuccess, fetchListFailure, redirectToLogin } from "./actions";
import Config from "config";
import axios from "axios";
function* fetchList(action) {
  const api = Config.backOffice.apiName;
  // const { token} = action.payload;
  const token = localStorage.getItem("auth_token_" + api);
  try {
    const response = yield axios.get(
      `https://www.fluxod.com/${api}/fdashboards/widget_dernieres_souscriptions`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    yield put(fetchListSuccess(response.data));
  } catch (error) {
    // yield put(fetchListFailure(error));
    yield put({ type: REDIRECT_TO_LOGIN });
  }
}

function* listSaga() {
  yield takeLatest(FETCH_LIST_REQUEST, fetchList);
}

export default listSaga;
